// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yuMEN8cwy0nXCzP23dbR{background:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;gap:16px;padding:16px;display:flex}.yuMEN8cwy0nXCzP23dbR .I7_JWhbiKXIJ2xAjELab,.yuMEN8cwy0nXCzP23dbR .ITsKyjGpecNFfYBjk5as{justify-content:space-between;align-items:center;display:flex}.yuMEN8cwy0nXCzP23dbR .I7_JWhbiKXIJ2xAjELab .hO8mg0WBHV0jkhfZMBvo,.yuMEN8cwy0nXCzP23dbR .ITsKyjGpecNFfYBjk5as .hO8mg0WBHV0jkhfZMBvo{align-items:center;gap:4px;display:flex}.yuMEN8cwy0nXCzP23dbR .I7_JWhbiKXIJ2xAjELab{height:24px}.yuMEN8cwy0nXCzP23dbR .ITsKyjGpecNFfYBjk5as{height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `yuMEN8cwy0nXCzP23dbR`,
	"row": `I7_JWhbiKXIJ2xAjELab`,
	"rowTitle": `ITsKyjGpecNFfYBjk5as`,
	"left": `hO8mg0WBHV0jkhfZMBvo`
};
export default ___CSS_LOADER_EXPORT___;
